import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import TabNavigation from '../../components/ui/TabNavigation';
import AudioPlayerBar from '../../components/ui/AudioPlayerBar';
import Icon from '../../components/AppIcon';
import ProfileSection from './components/ProfileSection';
import AudioSettingsSection from './components/AudioSettingsSection';
import PrivacySection from './components/PrivacySection';
import NotificationSection from './components/NotificationSection';
import SubscriptionSection from './components/SubscriptionSection';
import PaymentSection from './components/PaymentSection';
import SecuritySection from './components/SecuritySection';
import DataExportSection from './components/DataExportSection';

const UserProfileSettings = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [userData, setUserData] = useState({
    username: 'Александр Волков',
    bio: 'Создатель аутентичного контента о философии присутствия и осознанности. Вещаю из Silent Haven на Ко Пханган.',
    voiceDescription: 'Глубокий, медитативный голос с акцентом на паузы и тишину между словами.',
    location: 'Ко Пханган, Таиланд',
    website: 'https://authentic-voice.radio',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19a1d830b-1764700115566.png"
  });

  const [audioSettings, setAudioSettings] = useState({
    microphone: 'default',
    quality: 'high',
    format: 'mp3',
    bitrate: '320',
    sampleRate: '48000'
  });

  const [privacySettings, setPrivacySettings] = useState({
    profileVisibility: 'public',
    allowFollowers: true,
    showFollowerCount: true,
    allowComments: true,
    allowDownloads: true,
    showListeningHistory: true,
    dataSharing: true,
    analyticsTracking: true
  });

  const [notificationSettings, setNotificationSettings] = useState({
    email: {
      newFollowers: true,
      broadcastStarts: true,
      comments: true,
      donations: true,
      weeklyDigest: true
    },
    push: {
      newFollowers: true,
      broadcastStarts: true,
      comments: true,
      donations: true,
      liveReminders: true
    }
  });

  const [paymentSettings, setPaymentSettings] = useState({
    cryptoWallet: '',
    cardNumber: '',
    currency: 'btc'
  });

  const [securitySettings, setSecuritySettings] = useState({
    twoFactorEnabled: false
  });

  const [currentAudio] = useState({
    title: 'Философия Тишины',
    artist: 'Медитативные Частоты',
    artwork: "https://img.rocket.new/generatedImages/rocket_gen_img_11408f658-1764657846652.png",
    url: 'https://example.com/audio.mp3'
  });

  const handlePlayPause = () => {
    console.log('Play/Pause toggled');
  };

  const handleSeek = (time) => {
    console.log('Seek to:', time);
  };

  const handleVolumeChange = (volume) => {
    console.log('Volume changed to:', volume);
  };

  const handleNext = () => {
    console.log('Next track');
  };

  const handlePrevious = () => {
    console.log('Previous track');
  };

  const settingsTabs = [
  { id: 'profile', label: 'Профиль', icon: 'User' },
  { id: 'audio', label: 'Аудио', icon: 'Mic' },
  { id: 'privacy', label: 'Приватность', icon: 'Shield' },
  { id: 'notifications', label: 'Уведомления', icon: 'Bell' },
  { id: 'subscriptions', label: 'Подписки', icon: 'Users' },
  { id: 'payment', label: 'Платежи', icon: 'Wallet' },
  { id: 'security', label: 'Безопасность', icon: 'Lock' },
  { id: 'export', label: 'Экспорт', icon: 'Download' }];


  const handleUpdateProfile = (updatedData) => {
    setUserData((prev) => ({ ...prev, ...updatedData }));
    console.log('Profile updated:', updatedData);
  };

  const handleUpdateAudioSettings = (updatedSettings) => {
    setAudioSettings((prev) => ({ ...prev, ...updatedSettings }));
    console.log('Audio settings updated:', updatedSettings);
  };

  const handleUpdatePrivacy = (updatedSettings) => {
    setPrivacySettings((prev) => ({ ...prev, ...updatedSettings }));
    console.log('Privacy settings updated:', updatedSettings);
  };

  const handleUpdateNotifications = (updatedSettings) => {
    setNotificationSettings((prev) => ({ ...prev, ...updatedSettings }));
    console.log('Notification settings updated:', updatedSettings);
  };

  const handleUpdateSubscriptions = (updatedData) => {
    console.log('Subscriptions updated:', updatedData);
  };

  const handleUpdatePayment = (updatedSettings) => {
    setPaymentSettings((prev) => ({ ...prev, ...updatedSettings }));
    console.log('Payment settings updated:', updatedSettings);
  };

  const handleUpdateSecurity = (updatedSettings) => {
    setSecuritySettings((prev) => ({ ...prev, ...updatedSettings }));
    console.log('Security settings updated:', updatedSettings);
  };

  const handleExportData = (exportConfig) => {
    console.log('Exporting data:', exportConfig);
  };

  return (
    <>
      <Helmet>
        <title>Настройки профиля - Radio Co Im</title>
        <meta name="description" content="Управление профилем, настройками аудио, приватности и безопасности на платформе Radio Co Im" />
      </Helmet>
      <div className="user-profile-settings min-h-screen bg-background">
        <TabNavigation />

        <main className="settings-main lg:mr-80 pb-20 lg:pb-8">
          <div className="settings-container max-w-5xl mx-auto px-4 sm:px-6 py-8">
            <div className="settings-header mb-8">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name="Settings" size={24} color="var(--color-primary)" />
                </div>
                <div>
                  <h1 className="text-3xl font-heading font-semibold text-foreground">
                    Настройки
                  </h1>
                  <p className="text-sm text-muted-foreground">
                    Управление вашим профилем и предпочтениями
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-tabs mb-8 overflow-x-auto">
              <div className="flex gap-2 min-w-max pb-2">
                {settingsTabs?.map((tab) =>
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-200 whitespace-nowrap ${
                  activeTab === tab?.id ?
                  'bg-primary text-primary-foreground shadow-soft' :
                  'bg-card text-muted-foreground hover:text-foreground hover:bg-muted'}`
                  }>

                    <Icon
                    name={tab?.icon}
                    size={18}
                    color={activeTab === tab?.id ? 'var(--color-primary-foreground)' : 'currentColor'} />

                    <span className="text-sm font-medium">{tab?.label}</span>
                  </button>
                )}
              </div>
            </div>

            <div className="settings-content">
              {activeTab === 'profile' &&
              <ProfileSection
                userData={userData}
                onUpdate={handleUpdateProfile} />

              }

              {activeTab === 'audio' &&
              <AudioSettingsSection
                audioSettings={audioSettings}
                onUpdate={handleUpdateAudioSettings} />

              }

              {activeTab === 'privacy' &&
              <PrivacySection
                privacySettings={privacySettings}
                onUpdate={handleUpdatePrivacy} />

              }

              {activeTab === 'notifications' &&
              <NotificationSection
                notificationSettings={notificationSettings}
                onUpdate={handleUpdateNotifications} />

              }

              {activeTab === 'subscriptions' &&
              <SubscriptionSection
                subscriptions={[]}
                onUpdate={handleUpdateSubscriptions} />

              }

              {activeTab === 'payment' &&
              <PaymentSection
                paymentSettings={paymentSettings}
                onUpdate={handleUpdatePayment} />

              }

              {activeTab === 'security' &&
              <SecuritySection
                securitySettings={securitySettings}
                onUpdate={handleUpdateSecurity} />

              }

              {activeTab === 'export' &&
              <DataExportSection
                onExport={handleExportData} />

              }
            </div>
          </div>
        </main>

        <AudioPlayerBar
          audioSource={currentAudio}
          initialPlaybackState="paused"
          onPlayPause={handlePlayPause}
          onSeek={handleSeek}
          onVolumeChange={handleVolumeChange}
          onNext={handleNext}
          onPrevious={handlePrevious} />

      </div>
    </>);

};

export default UserProfileSettings;